<template>
  <v-card>
    <div class="fixed">
      <v-toolbar
        color="primary"
        dark
      >
        <v-toolbar-title>Notice</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-icon
          large
          class="mr-4"
          color="white"
          @click="refresh"
        >
          mdi-refresh
        </v-icon>
        <v-icon
          large
          class="mr-4"
          color="white"
          @click="readAll"
        >
          mdi-text-box-check-outline
        </v-icon>
        <v-icon
          large
          color="white"
          @click="toggleOrder"
        >
          {{ sortingIcon }}
        </v-icon>
      </v-toolbar>
      <section>
        <v-text-field
          v-model="searchKeyWord"
          label="Search..."
          class="mx-4 mt-5"
          hide-details
          append-icon="mdi-magnify"
        >
        </v-text-field>
      </section>
    </div>
    <v-list
      v-infinite-scroll="loadMore"
      class="scroll-list"
      :style="{ height: nodeHeight }"
      three-line
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="10"
    >
      <section
        v-for="(item, index) in items"
        :key="index"
      >
        <div
          class="card-content"
        >
          <v-list-item @click="handleRowClick(item,index)">
            <v-list-item-content>
              <v-list-item-title>
                <span
                  v-if="!item.isRead"
                  class="new-message-symbol"
                >
                  🔴
                </span>
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.content }}</v-list-item-subtitle>
              <span class="send-date mt-3">{{ formatDateTime(item.sentDate) }}</span>
              <!-- <span>{{ JSON.stringify(item) }}</span> -->
            </v-list-item-content>
          </v-list-item>
        </div>
      </section>
    </v-list>
    <v-dialog
      v-model="acceptTransferBookingDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ acceptBookingTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <accept-transfer-booking
            :booking-info="currentBooking"
            :dialog-status="acceptTransferBookingDialog"
            :notification-message="notificationMessage"
            :booking-transfer="bookingTransfer"
            :transfer-status-id="transferStatusID"
            @close="handleCloseDialog"
          ></accept-transfer-booking>
        </v-container>
      </v-card>
    </v-dialog>
    <ApproveAbnormalDialog
      v-model="attendanceDialog"
      :record="attendanceRecord"
      @close="handleCloseDialog"
    ></ApproveAbnormalDialog>
    <v-snackbar
      v-model="msgToast"
    >
      {{ message }}
    </v-snackbar>
  </v-card>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import { fetchList, updateMessage, markAllRead } from '@/api/notification'
import { getItem, getBookingTransfer } from '@/api/bookedCourse'
import { getItem as getAttendance } from '@/api/coachAttendance'
import AcceptTransferBooking from './COACH/BookingCalendar/AcceptTransferBooking.vue'
import ApproveAbnormalDialog from '@/views/pages/components/AttendanceManagement/ApproveAbnormalDialog.vue'
import { formatDateTime, loading } from '@/utils/helper'

const attendanceDialog = ref(false)
const defaultAttendancePlacement = {
  id: -1,
  userRecordID: -1, // 30040,
  centerID: -1,
  center: {
    description: '',
  },
  attendanceDate: '0001-01-01T00:00:00.000Z',
  checkinDateTime: '0001-01-01T00:00:00.0007Z',
  checkoutDateTime: '0001-01-01T00:00:00.0007Z',
  calculated: false,
  userRecord: {
    id: 30040,
    firstName: 'First Name', // Jason
    lastName: 'Last Name', // LI
    username: 'A230300001',
    userNo: 'A230300001',
    mobileNo: '12345678',
    fullName: 'First Name Last Name',
    avatar: 'User/Avatar/30040',
  },
  coachAttendanceAbnormal: {
    reason: '',
    checkoutDateTime: '0001-01-01T00:00:00.0007Z',
    abnormalApprovalStatusID: -1,
  },
}
const defaultBookingPlacement = {
  bookingNo: '',
  course: {
    courseCode: '',
    courseName: '',
  },
  userRecord: {
    fullName: '',
  },
  center: {
    description: '',
  },
  courseStartTime: '',
  courseEndTime: '',
}
const attendanceRecord = ref({ ...defaultAttendancePlacement })

const msgToast = ref(false)
const message = ref('')
function showMessage(msg) {
  message.value = msg
  msgToast.value = true
}

// const isLoading = ref(false)

const bookingTransfer = ref(null)
const transferStatusID = ref(-1)

const searchKeyWord = ref('')
const nodeHeight = ref('0px')
const orderByDesc = ref(true)

const acceptBookingTitle = ref('Acception Booking Transfer')

function updateNodeHeight() { nodeHeight.value = `${window.innerHeight - 180 - 60}px` }

const acceptTransferBookingDialog = ref(false)

const notificationMessage = ref('')

const currentBooking = ref({
  bookingNo: '',
  course: {
    courseCode: '',
    courseName: '',
  },
  userRecord: {
    fullName: '',
  },
  assignedCoach: {
    fullName: '',
  },
  center: {
    description: '',
  },
  courseStartTime: '',
  courseEndTime: '',
})

function handleCloseDialog() {
  console.log('handleCloseDialog')
  currentBooking.value = { ...defaultBookingPlacement }
  notificationMessage.value = null
  bookingTransfer.value = null
  transferStatusID.value = -1
  acceptTransferBookingDialog.value = false
  attendanceDialog.value = false
  attendanceRecord.value = { ...defaultAttendancePlacement }
}

const items = ref([])
function handleRowClick(item, index) {
  console.log(item, index)
  if (item.contentData) {
    notificationMessage.value = { ...item }
    const contentData = JSON.parse(item.contentData)
    loading(true)
    if (contentData) {
      if (contentData.type === 'BookingTransfer') {
        getBookingTransfer({
          id: contentData.data.id,
        }).then(response => {
          console.log('response', response)
          const { data } = response
          if (data) {
            if (data.toastMsg) {
              showMessage(data.toastMsg)

              // isLoading.value = false
              loading(false)
            } else if (data.record) {
              bookingTransfer.value = data.record
              transferStatusID.value = bookingTransfer.value.transferStatusID
              getItem(bookingTransfer.value.bookedCourseID).then(bookedCourseResponse => {
                currentBooking.value = bookedCourseResponse.data.record
                acceptTransferBookingDialog.value = true
              }).finally(() => {
                loading(false)
              })
            }
          }
        })
      } else if (contentData.type === 'AbnormalAttendance') {
        console.log('contentData.data', contentData.data)
        getAttendance(contentData.data.coachAttendanceID).then(response => {
          console.log('response', response)
          const { data } = response
          if (data) {
            if (data.toastMsg) {
              showMessage(data.toastMsg)

              // isLoading.value = false
              loading(false)
            } else if (data.record) {
              console.log('getAttendance', data.record)

              attendanceDialog.value = true
              attendanceRecord.value = data.record
              loading(false)

              // bookingTransfer.value = data.record
              // transferStatusID.value = bookingTransfer.value.transferStatusID
              // getItem(bookingTransfer.value.bookedCourseID).then(bookedCourseResponse => {
              //   currentBooking.value = bookedCourseResponse.data.record
              //   acceptTransferBookingDialog.value = true
              // }).finally(() => {
              //   loading(false)
              // })
            }
          }
        })
      }
    }
    console.log('item', item)
    if (item.id) {
      updateMessage({
        id: item.id,
      }).then(messageResponse => {
        console.log('updateMessage response', messageResponse)
        if (messageResponse.code === 20000) {
          items.value[index].isRead = true
          console.log('items.value[index]', items.value[index])
        }
      })
    }
  }
}

function fetchNotice() {
  return fetchList({
    searchKeyWord: searchKeyWord.value,
    OrderBy: 'SentDate',
    OrderDesc: orderByDesc.value,
  })
}

watch(searchKeyWord, val => {
  console.log('trigger searchKeyWord', val)

  // 0 would reset character 2 start to search
  if (val.length !== 1) {
    fetchNotice().then(response => {
      console.log('fetchNotice response', response)
      items.value.length = 0
      items.value.push(...response.data.items)
    })
  }
})

function refresh() {
  loading(true)
  fetchNotice().then(response => {
    console.log('fetchNotice response', response)
    items.value.length = 0
    items.value.push(...response.data.items)
  }).finally(() => {
    loading(false)
  })
}
function readAll() {
  loading(true)
  markAllRead().then(response => {
    console.log('markAllRead response', response)
    if (response.code === 20000) {
      refresh()
    }
  })
}

onMounted(() => {
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)
  refresh()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

const sortingIcon = ref('mdi-sort-variant') // mdi-sort-ascending

const busy = ref(false)

// const data = ref([])
// const count = ref(0)
function loadMore() {
  console.log('trigger loadMore')
  busy.value = true

  // setTimeout(() => {
  //   for (let i = 0, j = 10; i < j; i += 1) {
  //     data.value.push({ name: count.value += 1 })
  //   }
  //   busy.value = false
  // }, 1000)
}

function toggleOrder() {
  orderByDesc.value = !orderByDesc.value
  if (orderByDesc.value) {
    sortingIcon.value = 'mdi-sort-variant'
  } else {
    sortingIcon.value = 'mdi-sort-reverse-variant'
  }

  fetchNotice().then(response => {
    console.log('fetchNotice response', response)
    items.value.length = 0
    items.value.push(...response.data.items)
  })
}

function search() {
  console.log('searchKeyWord', searchKeyWord.value)
  if (searchKeyWord.value) {
    fetchNotice().then(response => {
      console.log('fetchNotice response', response)
      items.value.length = 0
      items.value.push(...response.data.items)
    })
  }
}

</script>
<style>
.send-date{
  text-align: right;
    font-size: 9px;
    color:rgba(72, 79, 84, 0.4)
}
.scroll-list{
  overflow-y: scroll;

  scrollbar-width: thin;
}
.scroll-list::-webkit-scrollbar {
  width: 12px;
  background: transparent;
}
.scroll-list::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
}
.new-message-symbol{
  font-size: 8px;
  vertical-align: middle;
}
</style>
